import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { getParsed } from '@/core/api/request';

const origins = z.array(z.object({ origin: z.string() })).transform((l) => l.map((x) => x.origin));
const destinations = z
  .array(z.object({ destination: z.string() }))
  .transform((l) => l.map((x) => x.destination));

export const catalogKeys = { cities: ['catalog', 'cities'] as const };

// فعلاً فقط مسیرهای فعال نمایش داده می‌شوند
const ACTIVE_ORIGINS = ['کرمان'];
const ACTIVE_DESTINATIONS = ['سیرجان', 'رفسنجان'];

/** Keeps the configured order and drops stations the API doesn't return. */
const restrict = (allowed: string[], available: string[]) => allowed.filter((x) => available.includes(x));

/** Origin/destination lists change rarely → cache aggressively. */
export function useCities() {
  return useQuery({
    queryKey: catalogKeys.cities,
    staleTime: 60 * 60 * 1000,
    queryFn: async () => {
      const [o, d] = await Promise.all([
        getParsed('passenger/origins-retrieve', origins),
        getParsed('passenger/destinations-retrieve', destinations),
      ]);
      return {
        origins: restrict(ACTIVE_ORIGINS, o),
        destinations: restrict(ACTIVE_DESTINATIONS, d),
      };
    },
  });
}
